import { formatDate } from '@angular/common';
import { ChangeDetectorRef, DestroyRef, inject, Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
  private translate = inject(TranslateService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
  private currentLang = this.translate.currentLang || 'sk';

  constructor() {
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      this.currentLang = event.lang;
      this.cdr.detectChanges();
    });
  }

  transform(value: Date | string | undefined, format: string = 'fullDate'): string {
    if (!value) return '';
    return formatDate(value, format, this.currentLang);
  }
}
